module.exports = __webpack_public_path__ + "officialStatic/img/znhjDetailList1.e26f23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/znhjDetailList1.png
// module id = JXdE
// module chunks = 0